import { Link, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import AuthCard from "../lotto/AuthCard";
import LoginForm from "./LoginForm";
import SignUpForm from "./SignUpForm";
import { useCustomColors } from "../../hooks/useCustomColors";

export type AuthMode = "login" | "signup";

interface AuthPanelProps {
  mode: AuthMode;
  /** Swap to the other mode without unmounting the surrounding shell. */
  onSwitch: (mode: AuthMode) => void;
  /** Renders the card's close button when provided (mobile dialog only). */
  onClose?: () => void;
  onSuccess?: () => void;
}

const COPY: Record<AuthMode, { title: string; subtitle: string; prompt: string; action: string }> = {
  login: {
    title: "login_player_title",
    subtitle: "login_subtitle",
    prompt: "login_no_account",
    action: "sign_up",
  },
  signup: {
    title: "sign_up_title",
    subtitle: "sign_up_subtitle",
    prompt: "sign_up_have_account",
    action: "login",
  },
};

const AuthPanel = ({ mode, onSwitch, onClose, onSuccess }: AuthPanelProps) => {
  const { t } = useTranslation();
  const colors = useCustomColors();
  const copy = COPY[mode];
  const other: AuthMode = mode === "login" ? "signup" : "login";

  return (
    <AuthCard
      embedded
      title={t(copy.title)}
      subtitle={t(copy.subtitle)}
      onClose={onClose}
      footer={
        <Typography sx={{ fontSize: "13px", color: colors.text.secondary }}>
          {t(copy.prompt)}{" "}
          <Link
            component="button"
            type="button"
            underline="none"
            onClick={() => onSwitch(other)}
            sx={{ fontSize: "13px", fontWeight: 800, color: colors.accent.gold }}
          >
            {t(copy.action)}
          </Link>
        </Typography>
      }
    >
      {mode === "login" ? (
        <LoginForm onSuccess={onSuccess} />
      ) : (
        <SignUpForm onSuccess={() => onSwitch("login")} />
      )}
    </AuthCard>
  );
};

export default AuthPanel;
